<template>
  <div class="dropdown-container">
    <!-- Dropdown Button -->
    <button @click="toggleDropdown" class="dropdown-button">
      <span class="dropdown-title">
        <span class="icon">👤</span> Providers ({{ selectedProviders.length }})
      </span>
      <span class="dropdown-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke-width="2"
          stroke="currentColor"
          class="menu-icon"
          :class="{ 'rotate-icon': isDropdownOpen }"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 9l6 6 6-6"
          />
        </svg>
      </span>
    </button>

    <!-- Dropdown Menu -->
    <div v-if="isDropdownOpen" class="dropdown-menu">
      <!-- Search Bar -->
      <div class="search-container">
        <div class="search-input-wrapper">
          <span class="search-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              class="search-svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21 21l-4.35-4.35m1.9-5.65a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z"
              />
            </svg>
          </span>
          <input
            type="text"
            v-model="searchTerm"
            placeholder="Search"
            class="search-input"
          />
        </div>
      </div>

      <!-- Clear Button -->
      <div v-if="selectedProviders.length > 0" class="clear-selection">
        <button @click="clearAll" class="clear-button">
          <span class="clear-icon">✖</span>
          <span class="clear-text">Clear All</span>
        </button>
      </div>

      <!-- Checkbox List -->
      <div class="checkbox-container">
        <div
          v-for="provider in filteredProviders"
          :key="provider.id"
          class="checkbox-item"
        >
          <input
            type="checkbox"
            :id="provider.id"
            :checked="selectedProviders.includes(provider.id)"
            @change="toggleProviderSelection(provider.id)"
            class="checkbox-input"
          />
          <label :for="provider.id" class="checkbox-label">
            <span v-if="provider.icon">
              <img 
                :src="provider.icon" 
                style="width: 24px; height: 24px; margin-right: 8px;" 
              />
            </span>
            {{ provider.name }} 
            <span> ({{ provider.count }})</span>
          </label>
        </div>
      </div>

      <!-- Save Options -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedProviders: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      providers: [],
      isDropdownOpen: false,
      searchTerm: "",
      providerLoading: false,
    };
  },
  computed: {
    filteredProviders() {
      if (!this.searchTerm) return this.providers;
      return this.providers.filter((provider) =>
        provider.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    clearAll() {
      // Emit an event to the parent to clear the selected providers
      this.$emit('update:selectedProviders', []);
    },
    toggleProviderSelection(providerId) {
      // Create a copy of the selectedProviders to avoid directly mutating the prop
      const updatedProviders = [...this.selectedProviders];
      const index = updatedProviders.indexOf(providerId);

      if (index > -1) {
        // Remove provider if it's already selected
        updatedProviders.splice(index, 1);
      } else {
        // Add provider to selection
        updatedProviders.push(providerId);
      }

      // Emit the updated selection to the parent component
      this.$emit('update:selectedProviders', updatedProviders);
    },
    async getAllCasinoProvider() {
      this.providerLoading = true;
      const url = `${process.env.VUE_APP_API_KEY}/api/secondary-provider/get-provider?limit=2000&status=true&provider_sort=1&site_auth_key=${process.env.VUE_APP_API_SITE_AUTH_KEY}`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        this.providers = data.data.map((provider) => ({
          id: provider.provider_id,
          name: provider.provider_name,
          count: provider.total_games,
          icon: provider.icon, // Default icon
        }));
        this.providerLoading = false;
      } catch (error) {
        console.error("Error fetching providers:", error);
        this.providerLoading = false;
      }
    },
  },
  mounted() {
    this.getAllCasinoProvider();
  },
};
</script>

<style scoped>
/* Dropdown Container */
.dropdown-container {
  width: 170px;
  position: relative;
}

/* Dropdown Button */
.dropdown-button {
  width: 100%;
  background-color: #2b2740;
  border-radius: 5px;
  padding: 10px;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border: none;
}

.dropdown-title {
  display: flex;
  align-items: center;
}

.icon {
  margin-right: 8px;
}

.dropdown-icon {
  font-size: 1rem;
  background-color: #3b3955; 
  height: 23px;
  width: 23px;
display: flex;
 justify-content: center;
 align-items: center;
  border-radius: 50%;

}

.menu-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.3s ease;
}

.rotate-icon {
  transform: rotate(180deg);
}

/* Dropdown Menu */
.dropdown-menu {
  position: absolute;
  width: 100%;
  background-color: #2b2740;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
  margin-top: -1px;
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
}

/* Search Bar */
.search-container {
  margin-bottom: 10px;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 8px;
  color: #8a8a8a;
}

.search-svg {
  width: 16px;
  height: 16px;
}

.search-input {
  width: 100%;
  padding: 8px 8px 8px 30px;
  border-radius: 5px;
  border: none;
  outline: none;
  background-color: #3b3955;
  color: white;
}

/* Clear Selection */
.clear-selection {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.clear-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  color: white;
  border: none;
  font-size: 12px;
  cursor: pointer;
  text-align: left;
  width: 100%;
  margin-left: -15px;
  margin-top: -15px;
}

.clear-icon {
  width: 16px;
  font-size: 12px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  border-radius: 3px;
  background-color: gray;
}

.clear-text {
  font-size: 12px;
  font-weight: 700;
}

/* Checkbox Items */
.checkbox-container {
  display: flex;
  flex-direction: column;
}

.checkbox-item {
  display: flex;
  align-items: center;
  /* margin-bottom: 10px; */
}

.checkbox-input {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  accent-color: #01BD71;
}

.checkbox-label {
  font-size: 12px;
  color: white;
  display: flex;
  
  align-items: center;
  text-align: left;
}

/* Action Buttons */
.action-buttons {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.save-button {
  background-color: #1e90ff;
  color: white;
  padding: 8px 10px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}
</style>
